import { render, staticRenderFns } from "./ui-metro.vue?vue&type=template&id=e50ce8f2&"
import script from "./ui-metro.vue?vue&type=script&lang=js&"
export * from "./ui-metro.vue?vue&type=script&lang=js&"
import style0 from "./ui-metro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e50ce8f2')) {
      api.createRecord('e50ce8f2', component.options)
    } else {
      api.reload('e50ce8f2', component.options)
    }
    module.hot.accept("./ui-metro.vue?vue&type=template&id=e50ce8f2&", function () {
      api.rerender('e50ce8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-metro/ui-metro.vue"
export default component.exports